export const CREATION_REPORT_TYPES = Object.freeze({
  INCIDENT: 'Real Incident',
  DRILL: 'Exercise',
});

const normalize = (value) => String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');

const isPlatformOnlyAdministrator = (user) => [
  ...(user?.saas_context?.platform_roles || []),
  ...(user?.platform_roles || []),
  ...(Array.isArray(user?.role) ? user.role : [user?.role]),
].map(normalize).some((role) => ['saas_superadmin', 'superadmin', 'super_admin'].includes(role));

const hasAuthoritativeInstitutionMembership = (user) => Boolean(
  user?._institution_roles_authoritative === true
  || user?.saas_context?.institution_roles_authoritative === true
  || user?.membership_id
  || user?.saas_context?.membership_id
);

const institutionRoleValuesForUser = (user) => {
  const contextRoles = user?.saas_context?.institution_roles || [];
  return hasAuthoritativeInstitutionMembership(user)
    ? contextRoles
    : [...contextRoles, ...(user?.institution_roles || [])];
};

export const isInstitutionIncidentAdministrator = (user) => {
  if (!user) return false;
  if (institutionRoleValuesForUser(user).map(normalize).includes('institution_admin')) return true;
  if (hasAuthoritativeInstitutionMembership(user)) return false;
  if (isPlatformOnlyAdministrator(user)) return false;
  return user.is_admin === true
    || normalize(user.web_access) === 'admin'
    || [user.role].flat().map(normalize).some((role) => role === 'admin');
};

export const creationAccessForUser = (user) => {
  const allowed = isInstitutionIncidentAdministrator(user);
  return { canCreateIncident: allowed, canCreateDrill: allowed };
};

export const resolveCreationReportType = (
  requestedType,
  { canCreateIncident = false, canCreateDrill = false } = {},
) => {
  if (requestedType === CREATION_REPORT_TYPES.DRILL && canCreateDrill) {
    return CREATION_REPORT_TYPES.DRILL;
  }
  if (requestedType === CREATION_REPORT_TYPES.INCIDENT && canCreateIncident) {
    return CREATION_REPORT_TYPES.INCIDENT;
  }
  if (canCreateIncident) return CREATION_REPORT_TYPES.INCIDENT;
  if (canCreateDrill) return CREATION_REPORT_TYPES.DRILL;
  return null;
};
